import React, {useEffect, useState} from "react";
import PageHeader from "../../components/organisms/PageHeader";
import request from "../../config/Axios";
import List from "../../components/organisms/List";

const Dstory = () => {
    const [row, setRow] = useState([]);
    const navList = [
        {
            name: "공지",
            link: "/notice/announcement"
        },
        {
            name: "캠페인",
            link: "/notice/campaign"
        },
        {
            name: "강아지숲 이야기",
            link: "/notice/dstory"
        },
        {
            name: "자주하는 질문",
            link: "/notice/faq"
        },
    ];

    useEffect( () => {
        (async ()=>{
            try {
                const dstoryResponse = await request.get(`boards/dstory/posts`);
                setRow(dstoryResponse.data.data.postList);
            } catch (err) {
                console.error('api 호출 중 에러 발생:', err);
            }
        })();
    }, []);
    return (
        <>
            <PageHeader
                bTitle="알림"
                detail="강아지숲 이야기"
                desc="강아지숲 이야기를 안내해 드립니다."
                list={navList}
                top={true}
            />
            <List
                row={row}
                columns={3}
                category={"강아지숲 이야기"}
                pagination={false}
            />
        </>
    );
};

export default Dstory;
